import { CmxState } from 'app/dux/cmx/interfaces';
import { cmxReducer } from 'app/dux/cmx/reducer';
import { GroupsAppState, groupsReducer } from 'app/dux/groups';
import { PlayAppState } from 'app/dux/play/interfaces';
import { playReducer } from 'app/dux/play/reducer';
import { ProgramsAppState, programsReducer } from 'app/dux/programs';
import { sessionReducer } from 'app/dux/session/reducer';
import { SessionAppState } from 'app/dux/session/types';
import { combineReducers } from 'redux';
import { arcadeSharedReducers } from 'routes/arcade/reducers';
import { ArcadesState } from 'routes/arcades/interfaces';
import { arcadesReducer } from 'routes/arcades/reducer';
import { RomEditorState } from 'routes/rom/interfaces';
import { romReducer } from 'routes/rom/reducer';
import { RomsState } from 'routes/roms/interfaces';
import { romsReducer } from 'routes/roms/reducer';
import { TokenBuilderAppState, tokenBuilderReducer } from 'routes/tokens/create/dux';

export type AppState =
    {
        readonly arcade: unknown;
        readonly arcades: ArcadesState;
        readonly roms: RomsState;
        readonly rom: RomEditorState;
        readonly cmx: CmxState;
    } &
    PlayAppState &
    GroupsAppState &
    ProgramsAppState &
    SessionAppState &
    TokenBuilderAppState;

export default combineReducers<AppState>({
    play: playReducer,
    arcade: arcadeSharedReducers,
    arcades: arcadesReducer,
    groups: groupsReducer,
    programs: programsReducer,
    rom: romReducer,
    roms: romsReducer,
    cmx: cmxReducer,
    session: sessionReducer,
    tokenBuilder: tokenBuilderReducer,
});
